import * as types from '../actions/actionTypes'


const clientRegistrationsReducer = (state = {
    allClientRegistrations: [],
}, action) => {

    switch(action.type) {
      case types.GET_ALL_CLIENT_REGISTRATIONS_SUCCESS: 
      state = {
        ...state,
        allClientRegistrations: action.payload,
      };
      break;
      case types.UPDATE_SUBMIT_ON_CLIENT_REGISTRATION:
     
      let tempRegistrations = state.allClientRegistrations
      for (var registrationKey in tempRegistrations) {
        if (tempRegistrations[registrationKey].nodeName == action.payload){
          tempRegistrations[registrationKey].submitted = true
        }
       }

      state = {
        ...state,
        allClientRegistrations: tempRegistrations,
      };
      break;
      case types.SET_CURRENT_COMPANY: 
      //if logging in with a different company wipe all of the store 
      state = {
        ...state,
        allClientRegistrations: action.payloadTwo ? state.allClientRegistrations : [],
      };
      break;
      default:
      break;    
    }

    return state;
};


export default clientRegistrationsReducer;


// WEBPACK FOOTER //
// ./src/reducers/clientRegistrationsReducer.js